import { MonitoringSeriesTypeEnum } from '../../../Monitor/Shared/enums/monitoring-series-type.enum';

export enum MentionSourceApiTypesEnum {
    TOPIC = 'TOPIC',
    SUBSCRIPTION = 'SUBSCRIPTION',
    FOLDER = 'FOLDER',
    SOURCE_GROUP = 'SOURCE_GROUP',
    AGENT = 'AGENT',
    THEME = 'THEME',
    AI_AGENT = 'AI_AGENT',
    TAG = 'TAG',
    TAG_GROUP = 'TAG_GROUP',
    ALL_SAVED_COVERAGE = 'ALL_SAVED_COVERAGE',
    COVERAGE_IN_SECTION = 'COVERAGE_IN_SECTION',
    ALL_CURATED_COVERAGE = 'ALL_CURATED_COVERAGE',
    COVERAGE_SURGE = 'COVERAGE_SURGE'
}

export const monitoringSeriesTypeEnumToMentionSourceApiTypesEnum: Map<MonitoringSeriesTypeEnum, MentionSourceApiTypesEnum> = new Map([
    [MonitoringSeriesTypeEnum.topic, MentionSourceApiTypesEnum.TOPIC],
    [MonitoringSeriesTypeEnum.subscription, MentionSourceApiTypesEnum.SUBSCRIPTION],
    [MonitoringSeriesTypeEnum.folder, MentionSourceApiTypesEnum.FOLDER],
    [MonitoringSeriesTypeEnum.sourceGroup, MentionSourceApiTypesEnum.SOURCE_GROUP],
    [MonitoringSeriesTypeEnum.socialTopic, MentionSourceApiTypesEnum.AGENT],
    [MonitoringSeriesTypeEnum.theme, MentionSourceApiTypesEnum.THEME],
    [MonitoringSeriesTypeEnum.aiAgent, MentionSourceApiTypesEnum.AI_AGENT],
    [MonitoringSeriesTypeEnum.tag, MentionSourceApiTypesEnum.TAG],
    [MonitoringSeriesTypeEnum.tagGroup, MentionSourceApiTypesEnum.TAG_GROUP],
    [MonitoringSeriesTypeEnum.allSavedCoverage, MentionSourceApiTypesEnum.ALL_SAVED_COVERAGE],
    [MonitoringSeriesTypeEnum.coverageInSection, MentionSourceApiTypesEnum.COVERAGE_IN_SECTION],
    [MonitoringSeriesTypeEnum.allCuratedCoverageInBrief, MentionSourceApiTypesEnum.ALL_CURATED_COVERAGE],
    [MonitoringSeriesTypeEnum.coverageSurge, MentionSourceApiTypesEnum.COVERAGE_SURGE],
]);


export const mentionSourceApiTypesEnumToMonitoringSeriesTypeEnum: Map<MentionSourceApiTypesEnum, MonitoringSeriesTypeEnum> = new Map([
    [MentionSourceApiTypesEnum.TOPIC, MonitoringSeriesTypeEnum.topic],
    [MentionSourceApiTypesEnum.SUBSCRIPTION, MonitoringSeriesTypeEnum.subscription],
    [MentionSourceApiTypesEnum.FOLDER, MonitoringSeriesTypeEnum.folder],
    [MentionSourceApiTypesEnum.SOURCE_GROUP, MonitoringSeriesTypeEnum.sourceGroup],
    [MentionSourceApiTypesEnum.AGENT, MonitoringSeriesTypeEnum.socialTopic],
    [MentionSourceApiTypesEnum.THEME, MonitoringSeriesTypeEnum.theme],
    [MentionSourceApiTypesEnum.AI_AGENT, MonitoringSeriesTypeEnum.aiAgent],
    [MentionSourceApiTypesEnum.TAG, MonitoringSeriesTypeEnum.tag],
    [MentionSourceApiTypesEnum.TAG_GROUP, MonitoringSeriesTypeEnum.tagGroup],
    [MentionSourceApiTypesEnum.ALL_SAVED_COVERAGE, MonitoringSeriesTypeEnum.allSavedCoverage],
    [MentionSourceApiTypesEnum.COVERAGE_IN_SECTION, MonitoringSeriesTypeEnum.coverageInSection],
    [MentionSourceApiTypesEnum.ALL_CURATED_COVERAGE, MonitoringSeriesTypeEnum.allCuratedCoverageInBrief],
    [MentionSourceApiTypesEnum.COVERAGE_SURGE, MonitoringSeriesTypeEnum.coverageSurge],
]);

